import { Key } from '@platform/shortcuts/utils/keyboard-platform';
import { useCallback, useEffect, useRef } from 'react';
import { useKeyEventListener } from 'expo-key-event';

/**
 * Listens for the Escape key and invokes `onClose` when pressed.
 * The listener is only active while `onClose` is defined and automatically
 * cleans up on unmount or when the listener is disabled.
 */
export const useEscapeKeyClose = (onClose?: () => void) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const listener = useCallback((event: { key: string }) => {
    if (event.key === Key.Escape) {
      onCloseRef.current?.();
    }
  }, []);

  const { startListening, stopListening } = useKeyEventListener(listener);

  const isEnabled = Boolean(onClose);

  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    startListening();
    return () => {
      stopListening();
    };
  }, [isEnabled, startListening, stopListening]);
};
